import { MD3LightTheme, configureFonts } from 'react-native-paper';

const fontConfig = {
  fontFamily: 'System',
};

export const colors = {
  primary: '#00abc8',
  primaryDark: '#02afc7',
  primaryLight: '#e6f7fa',
  secondary: '#32373c',
  background: '#ffffff',
  surface: '#f5f5f5',
  error: '#c31515',
  warning: '#ffc107',
  success: '#28a745',
  info: '#17a2b8',
  text: '#212529',
  textPrimary: '#212529',
  textSecondary: '#6c757d',
  border: '#dee2e6',
  disabled: '#e9ecef',
  
  // Review status colors
  statusNotStarted: '#c31515',
  statusInProgress: '#ffc107',
  statusCompleted: '#28a745',
  
  // Additional grays
  gray50: '#f8fafc',
  gray100: '#f8f9fa',
  gray200: '#e9ecef',
  gray300: '#dee2e6',
  gray400: '#ced4da',
  gray500: '#adb5bd',
  gray600: '#6c757d',
  gray700: '#495057',
  gray800: '#343a40',
  gray900: '#212529',
};

export const theme = {
  ...MD3LightTheme,
  colors: {
    ...MD3LightTheme.colors,
    primary: colors.primary,
    primaryLight: '#e6f7fa',
    secondary: colors.secondary,
    tertiary: colors.primaryDark,
    surface: colors.surface,
    background: colors.background,
    backgroundLight: colors.gray100,
    border: colors.border,
    text: colors.text,
    textSecondary: colors.textSecondary,
    error: colors.error,
    onPrimary: '#ffffff',
    onSecondary: '#ffffff',
    onSurface: colors.text,
    onBackground: colors.text,
    elevation: {
      ...MD3LightTheme.colors.elevation,
      level1: colors.gray100,
      level2: colors.gray200,
      level3: colors.gray300,
    },
  },
  fonts: configureFonts({ config: fontConfig }),
  roundness: 8,
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

export const typography = {
  h1: {
    fontSize: 32,
    fontWeight: 'bold' as const,
    lineHeight: 40,
  },
  h2: {
    fontSize: 24,
    fontWeight: 'bold' as const,
    lineHeight: 32,
  },
  h3: {
    fontSize: 20,
    fontWeight: '600' as const,
    lineHeight: 28,
  },
  h4: {
    fontSize: 18,
    fontWeight: '600' as const,
    lineHeight: 24,
  },
  body1: {
    fontSize: 16,
    fontWeight: 'normal' as const,
    lineHeight: 24,
  },
  body: {
    fontSize: 16,
    fontWeight: 'normal' as const,
    lineHeight: 24,
  },
  bodyBold: {
    fontSize: 16,
    fontWeight: '600' as const,
    lineHeight: 24,
  },
  body2: {
    fontSize: 14,
    fontWeight: 'normal' as const,
    lineHeight: 20,
  },
  caption: {
    fontSize: 12,
    fontWeight: 'normal' as const,
    lineHeight: 16,
  },
};

export const shadows = {
  sm: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  md: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 4,
  },
  lg: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 8,
  },
};
